import Checkbox from "../general/input/Checkbox";
import {useDispatch, useSelector} from "react-redux";
import {setRememberMe} from "../../../redux/slice/authSlice";
import ComponentRenderer from "../../core/context/componentRegistry/ComponentRenderer";
import AlwaysRememberMe from "./AlwaysRememberMe";


//eslint-disable-next-line
const DefaultRememberMe = () => {

    const dispatch = useDispatch();
    const { rememberMe } = useSelector(state => state.local.auth);

    // if(rememberMe == null) {
    //     dispatch(setRememberMe({isChecked: false}))
    // }

    const onCheckedChange = (isChecked) => {
        dispatch(setRememberMe({isChecked}))
    }

    return (
        <div className="sign-in-remember-me">
            <Checkbox
                isChecked={rememberMe}
                onCheckedChange={onCheckedChange}
            />
            <p className="sign-in-sub-heading">Remember me</p>
        </div>
    )
}

const RememberMe = () => {
    return <ComponentRenderer componentName="rememberMe" defaultComponent={AlwaysRememberMe} />
}

export default RememberMe;
